import { render } from "./staff-search.vue?vue&type=template&id=39cb1584"
import script from "./staff-search.vue?vue&type=script&lang=js"
export * from "./staff-search.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__